export const ResetPassword = {
	title: "Reset Password",
	expalantion: "Enter your new password below to reset your account password.",
	repet_password_label: "Repeat password",
	button_text: "Reset Password",
	loading_button_text: "Resetting...",
	remember_password_text: "Remember your password? ",
	login_button_text: "Login",
	success_titel: "Password Reset Successful",
	success_explanation: "Your password has been successfully reset. You can now log in with your new password.",
};
